import template from "./entity-business-charge-modal.html";
import "./entity-business-charge-modal.less";
import { EVENT_LOGOUT } from "../../../../../../../../constants";
import swal from "sweetalert2";
import { isStringNullishOrEmpty } from "../../../../../../../../services/string-service";

export function controller(loadingService, eventBus, $scope, $logger) {
	const ctrl = this;
	ctrl.chargeTypes = [
		{ Code: "PERCENT", label: "Percentage" },
		{ Code: "FLAT", label: "Flat Rate" }
	];

	ctrl.promiseTracker = loadingService.getTracker();

	ctrl.$onDestroy = ctrl.cancel;

	ctrl.$onInit = () => {
		ctrl.charge = { ...ctrl.resolve.charge };
		eventBus.register(EVENT_LOGOUT, () => { ctrl.cancel(); }, $scope);
	};

	ctrl.onOk = async() => {
		if(!validate()) {
			return;
		}

		const result = await ctrl.resolve.save(ctrl.charge);
		ctrl.modalInstance.close(result);
	};

	ctrl.cancel = () => {
		ctrl.modalInstance.dismiss();
	};

	ctrl.setTemplate = (templateName) => {
		switch(templateName) {
			case "state-sales-tax": {
				ctrl.charge.Name = "State Sales Tax";
				ctrl.charge.Type = ctrl.chargeTypes.find(t => t.Code === "PERCENT");
				break;
			}
			case "county-sales-tax": {
				ctrl.charge.Name = "County Sales Tax";
				ctrl.charge.Type = ctrl.chargeTypes.find(t => t.Code === "PERCENT");
				break;
			}
			case "fee": {
				ctrl.charge.Name = "Fee";
				ctrl.charge.Type = ctrl.chargeTypes.find(t => t.Code === "FLAT");
				break;
			}
			default:
				break;
		}
	};

	function validate() {
		const validationStrings = [];

		if(isStringNullishOrEmpty(ctrl.charge.Name)) {
			validationStrings.push("Tax or fee name is required.");
		}

		if(isStringNullishOrEmpty(ctrl.charge.Value?.toString())) {
			validationStrings.push("Tax or fee amount is required.");
		}

		if(isStringNullishOrEmpty(ctrl.charge.Type?.Code)) {
			validationStrings.push("Tax or fee type is required.");
		}

		if(validationStrings.length > 0) {
			const errorList = `<ul><li>${validationStrings.join("</li><li>")}</li></ul>`;
			
			swal.fire({
				title: "Missing required fields",
				html: 
					`<p>Please correct the following errors</p>
					${errorList}
					`,
				showCloseButton: true,
				type: "warning"
			});
			
			return false;
		}

		return true;
	}
}

export default angular.module("vesl.components.entity-business-charge-modal", [])
	.component("entityBusinessChargeModal", {
		controller,
		template,
		bindings: {
			close: "&",
			dismiss: "&",
			modalInstance: "<",
			resolve: "<",
			reload: "&"
		}
	})
	.name;
